import type { Ref } from 'react';
import { type CustomIconName, Icon } from '@/components/Icon/Icon';
import classes from './IconButton.module.css';
import { type Icon as FeatherIcon } from 'react-feather';

interface IconButtonBaseProps {
  /**
   * Optional icon size
   */
  iconSize?: number;
  /**
   * Color of icon
   */
  color?: string;
  /**
  /**
   * Optional click handler
   */
  onClick?: () => void;
  ref?: Ref<HTMLButtonElement>;
}

type IconButtonProps =
  | (IconButtonBaseProps & { name: CustomIconName; Component?: never })
  | (IconButtonBaseProps & { Component: FeatherIcon; name?: never });

export const IconButton = ({
  name,
  Component,
  iconSize = 20,
  color = 'black',
  ...props
}: IconButtonProps) => {
  return (
    <button type="button" {...props} className={classes.iconButton}>
      {Component && (
        <Icon Component={Component} color={color} size={iconSize} />
      )}
      {name && <Icon name={name} color={color} size={iconSize} />}
    </button>
  );
};
